import React from "react";
import PropTypes from "prop-types";
import Course from "../../../components/adm/course/courseForm";
import Layout from "../../../components/layouts/verticalLayout";
import { useParams } from "react-router-dom";

const CourseFormPage = () => {
  let { uuid } = useParams();
  return <Layout body={<Course uuid={uuid} />} />;
};

CourseFormPage.propTypes = {};

export default CourseFormPage;
